var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Do not edit this file, it is auto generated
 */
import { StyledSvgIcon } from '../../styles/svg-icon.styled';
export const SocialFacebookIcon = (_a) => {
    var { size = 'md' } = _a, props = __rest(_a, ["size"]);
    return (_jsx(StyledSvgIcon, Object.assign({ xmlSpace: "preserve", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", "$size": size }, props, { children: _jsx("path", { d: "M21.737 16h-3.736v13.342h-5.604V16H9.729v-4.803h2.668V8.262c0-2.135 1.067-5.604 5.604-5.604h4.003v4.536h-2.935c-.533 0-1.067.267-1.067 1.334v2.668h4.269z" }) })));
};
